import BaseOptionsComponentController from '../base_options_component_controller';
import Model from './touch_id_model';
import {TOUCH_ID_SCREENS} from './touch_id_component_consts';
import {SYSTEM_EVENTS} from '../../../../events/events';
import Event from '../../../../utils/event';
import {PRIORITY_LEVEL} from '../../../../services/overlay_manager/overlay_manager_levels';
import TouchIdAutoInitScreen from './Screens/touch_id_screen_init';
import TouchIdModifyScreen from './Screens/touch_id_screen_modify';

class TouchIdController extends BaseOptionsComponentController {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'TouchIdController';


    /**
     * @static
     * @type {string}
     */
    static DIRECTIVE = 'cgp-directive-touch-id';


    /**
     * Root component selector.
     *
     * @type {string}
     * @private
     */
    _selector = 'cgp-touch-id-component';


    /**
     * @property screen type
     * @type {int}
     * @private
     */
    _screenType = TOUCH_ID_SCREENS.INIT_SCREEN;

    /**
     * @property screen type
     * @type {object|null}
     * @private
     */
    _currentScreen = null;


    /**
     * @property
     * @type {object|null}
     * @private
     */
    _model = null;

    init(params) {
        super.init();
        this._model = Model.create(params);

        this._subscribe();
    }


    _subscribe() {
        Event.on(SYSTEM_EVENTS.TOUCH_ID_TRY_AGAIN_SKIP, this._onTryAgainSkip, this);
        Event.on(SYSTEM_EVENTS.TOUCH_ID_TOKEN_ENABLE_RES, this._onCheckTouchEnable, this);
        Event.on(SYSTEM_EVENTS.TOUCH_ID_NATIVE_CANCEL, this._onNativeCancel, this);

        Event.fire(TOUCH_ID_SCREENS.TOUCH_ID_CTL_OPENED);
    }

    _onNativeCancel() {
        this._currentScreen.onNativeCancel();
    }
    _onTryAgainSkip() {
        this._currentScreen.onTryAgainSkip();
    }

    _onCheckTouchEnable(bChecked) {
        // TODO
        this._currentScreen.onCheckTouchEnable(bChecked);
    }

    setScreen(screenType) {
        this._screenType = screenType;
    }


    _setHtmlScreen() {
        this._currentScreen = null;
        switch (this._screenType) {
            case TOUCH_ID_SCREENS.INIT_SCREEN:
                this._currentScreen = TouchIdAutoInitScreen.create();
                break;
            case TOUCH_ID_SCREENS.MODIFY_SCREEN:
                this._currentScreen = TouchIdModifyScreen.create();
                break;
            default:
                /* Maybe should throw an exception */
                break;
        }

        this._currentScreen && this._currentScreen.setParent(this).show();
    }


    /**
     *
     * @returns {TouchIdController}
     */
    start() {
        this._setHtmlScreen();
        this._openInMDP();

        return this;
    }


    /**
     * Wrapper to close component overlay
     * @returns
     * @public
     */
    close() {
        super.destroy();
    }

    getTokenFromSrv() {
        Event.fire(SYSTEM_EVENTS.TOUCH_ID_GET_TOKEN_FROM_SRV);
    }

    checkTouchEnable() {
        Event.fire(SYSTEM_EVENTS.TOUCH_ID_CHECK_TOKEN_ENABLE);
    }


    getCurrentScreen() {
        return this._currentScreen;
    }

    /**
     * Get touch id message priority
     * @returns {*}
     */
    getOverlayPriority() {
        return PRIORITY_LEVEL.TOUCH_ID;
    }


    /**
     * Handle after component open action
     * @protected
     */
    onComponentOpened() {
        this._currentScreen.onComponentOpened();
    }


    /**
     * Callback fired when component is completly removed from DOM
     * @protected
     */
    onComponentClosed() {
        this._currentScreen.onClosedByClicked();
        Event.fire(TOUCH_ID_SCREENS.TOUCH_ID_CTL_CLOSED);
        super.onComponentClosed();
    }


    /**
     * Handle overlay close button click
     */
    onCloseBtnClicked() {
        // Event.fire(TOUCH_ID_SCREENS.TOUCH_ID_CTL_CLOSED);
    }


    _getCustomCSSClassList() {
        return super._getCustomCSSClassList().concat(['cgp-options-touch-id', 'mdp-tablet-full-size']);
    }


    _getButtons() {
        return this._currentScreen._getButtons();
    }

    _getTitleKey() {
        return 'touch_id_auto_screen'
    }

    _openInMDP() {
        Event.fire(SYSTEM_EVENTS.MESSAGE_OPEN, {
            contentEl: this._currentScreen.getEl(),
            title: this._getOptionTitle(),
            closeButton: true,
            hasDefaultButton: false,
            customCSSClassList: this._getCustomCSSClassList(),
            priority: this.getOverlayPriority(),
            buttons: this._getButtons(),
            openCallback: this.onComponentOpened.bind(this),
            closeCallback: this.onComponentClosed.bind(this),
            btnCloseCallback: this.onCloseBtnClicked.bind(this)
        });
    }

}
export default TouchIdController;